import { Component, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ResponseAnalyticsService } from 'src/app/shared/services/response-analytics/response-analytics.service';
import { HelpersService } from 'src/app/shared/services/helpers/helpers.service';
import * as _ from 'lodash';
import { ScoreSearchBarComponent } from '../score-search-bar/score-search-bar.component';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { DownloadService } from 'src/app/shared/services/downloads/download.service';
import { environment } from 'src/environments/environment';
import * as moment from 'moment';
import { NgClass, NgIf } from '@angular/common';
import { ScoreWidgetComponent } from '../score-widget/score-widget.component';
import { LtmsLoaderComponent } from '../../ltms-loader/ltms-loader.component';
import { ScoreTableComponent } from '../score-table/score-table.component';
import { ScoreComparisonToggleComponent } from '../score-comparison-toggle/score-comparison-toggle.component';
import {
  attachSummaryDeviations,
  getComparisonPeriodLabel,
  getShowComparisonFlag,
  isComparisonAvailable,
  setShowComparisonFlag,
} from 'src/app/shared/utils/score-deviation.util';
import { applyComparisonApiDateRange } from 'src/app/shared/utils/comparison-api-date-range.util';
@Component({
    selector: 'app-score-details',
    templateUrl: './score-details.component.html',
    styleUrl: './score-details.component.scss',
    imports: [NgClass, ScoreSearchBarComponent, ScoreWidgetComponent, NgIf, LtmsLoaderComponent, ScoreTableComponent, ScoreComparisonToggleComponent]
})

export class ScoreDetailsComponent implements OnInit, OnDestroy {
  @ViewChildren(ScoreSearchBarComponent) children: QueryList<ScoreSearchBarComponent> | undefined;
  scalerRaterType: string | number = '';
  datefilterCache: any = {};
  universalFilterCache: any = {};

  isLoading: boolean = true;
  isError: boolean = false;

  headerLabels: any = {};
  isKeywords: boolean = false;
  isPhrases: boolean = false;
  showComparisonFlag: boolean = false;
  isComparisonAvailable: boolean = true;
  dateType: string = '';
  comparisonPeriodLabel: string = '';
  isTotalProject: boolean = true;
  totalProject: number = 0;
  searchText: string = '';
  table: any = {
    tablePlugins: {
      headerBackgroundColorHide: true,
      headerBottomBorder: true,
      tableBorder: true,
      isTableResize: false,
      deviationAlignment: true,
      alignAllDeviationColumns: true,
    },
    header: [],
    row: [],
    footer: []
  };
  tableDropdown: any = {};
  widgetTool: any = {
    isDownloadButtonShow: true,
  };
  distributionSearchPlaceHolder: string = '';
  downloadThroughAPIDistribution: boolean = false;
  downloadThroughAPICompareWith: boolean = false;
  overallTotal: number = 0;
  isCardOneError: boolean = false;
  isCardTwoError: boolean = false;
  compareWithSearchPlaceHolder: string = '';
  isCardTwoLoading: boolean = true;
  comapreWithTable: any = {
    tablePlugins: {
      isTableResize: false
    },
    tableHeader: [],
    tableRow: [],
    tableFooter: []
  };
  searchcompareWithText: string = '';
  selectedCompareWithOption: string = '';
  compareWithFieldId: any = '';
  compareWithFieldType: any = '';
  distributionFieldId: any = '';
  distributionFieldType: any = '';
  compareDropdownFieldId: any = '';
  distributionTable: any = {
    tablePlugins: {
      isTableResize: false
    },
    tableHeader: [],
    tableRow: [],
    tableFooter: []
  };

  fieldId: string = '';
  fieldType: string = '';
  totalCount: any = 0;
  previousTotalCount: number = 0;
  footerCurrentSummary: any = null;
  footerPreviousSummary: any = null;
  brandId:any = null;
  accountId :any = null
  accessLevelandValue:any = null
  selectedOption: any;

  onShowComparisonChange(checked: boolean): void {
    this.showComparisonFlag = checked;
    setShowComparisonFlag(checked);
  }

  private refreshComparisonLabels(): void {
    this.dateType =
      _.get(Helpers, 'datePicker.trendType') ||
      _.get(Helpers, 'datePicker.selectedTrend') ||
      'period';
    this.comparisonPeriodLabel = getComparisonPeriodLabel();
    this.isComparisonAvailable = isComparisonAvailable();
    if (!this.isComparisonAvailable) {
      this.showComparisonFlag = false;
      setShowComparisonFlag(false);
    } else {
      this.showComparisonFlag = getShowComparisonFlag();
    }
  }

  onButtonClick(event: any): void {
    this.isLoading = true;
    this.isKeywords = event.name === 'keywords' ? !this.isKeywords : false;
    this.isPhrases = event.name === 'phrases' ? !this.isPhrases : false;
    if(this.isKeywords || this.isPhrases) {
      this.isTotalProject = false;
      this.fieldId = event.fieldId;
      this.fieldType = event.fieldType;
      this.prepareHeaderForTable();
      this.callAPIforFooter();
    } else {
      this.isTotalProject = true;
      this.tableDropdown.selectedOption = 'Sub Accounts / Projects';
      this.fieldId = 'project';
      this.fieldType = 'project';
      this.prepareHeaderForTable();
      this.callAPIforFooter();
    }
  }

  onDropdown(event: any): void {
    this.isLoading = true;
    this.tableDropdown.selectedOption = event.name;
    this.fieldId = event.field_id;
    this.fieldType = event.field_type || 'tag';
    this.prepareHeaderForTable();
    this.callAPIforFooter();
    if(event.field_type === 'project') {
      this.isTotalProject = true;
    } else {
      this.isTotalProject = false;
    }
  }

  onSearch(event: any): void {
    this.searchText = event;
  }

  private destroy$ = new Subject<void>();

  constructor(
    private responseAnalyticsService: ResponseAnalyticsService,
    private helpersService: HelpersService,
    private downloadService: DownloadService, 
    private toastService: ToastService,
  ) {}

  ngOnInit(): void {
    this.refreshComparisonLabels();
    let responseAnalyticsServiceResponseCame: boolean = false;
    let helperServiceResponseCame: boolean = false;
    this.responseAnalyticsService.ratingInfo.pipe(takeUntil(this.destroy$)).subscribe(response => {
      if(response && response?.scalerType != this.scalerRaterType) {
        responseAnalyticsServiceResponseCame = true;
        this.scalerRaterType = response?.scalerType;
        if(helperServiceResponseCame) {
          this.execute();
          this.callAPIforFooter();
        }
      }
    })
    this.helpersService.appState.pipe(takeUntil(this.destroy$)).subscribe(response => {
      if(response && response.pending === false) {
        this.refreshComparisonLabels();
        let datePickerObj = _.cloneDeep(response.datePicker);
        let universalFilterObj = _.cloneDeep(response.universalFilter);
        let datePicker = _.cloneDeep(this.datefilterCache);
        let universalFilter = _.cloneDeep(this.universalFilterCache);
        if(datePickerObj != datePicker || universalFilterObj != universalFilter) {
          helperServiceResponseCame = true;
          this.datefilterCache = _.cloneDeep(response.datePicker);
          this.universalFilterCache = _.cloneDeep(response.universalFilter);
          if(responseAnalyticsServiceResponseCame) {
            if(_.hasIn(response,'accountDetails._id')){
              if(response.accountDetails._id != this.accountId){
                this.accountId = response.accountDetails._id
                this.execute();
                this.callAPIforFooter();
              }else{
                this.callAPIforFooter();
              }
            }else{
              console.log("Account Details not loaded...")
            }
          }
        }
      }
    })
  }

  execute(): void {
    this.prepareDropdown();
  }

  private prepareDropdown(): void {
    let dropdown: any = {
      selectedOption: '',
      options: [
        {name: 'Sub Accounts / Projects', field_id: 'project', field_type: 'project'}
      ]
    };
    const fieldDefinitions: any = _.get(Helpers, 'accountDetails.field_definitions', null);
    if(fieldDefinitions) {
      fieldDefinitions.forEach((fieldDefinition: any) => {
        if(fieldDefinition?.compare_filter && fieldDefinition?.es_filter) {
          dropdown.options.push({name: fieldDefinition?.name, field_id: fieldDefinition?.field_id, field_type: fieldDefinition?.field_type});
        }
      })
    }
    dropdown.selectedOption = dropdown.options[0].name;
    this.tableDropdown = dropdown;
    if(this.fieldId != 'unigrams' && this.fieldId != 'bigrams') {
      this.fieldId = 'project';
      this.fieldType = 'project';
    }
    this.prepareHeaderForTable();
  }

  private prepareHeaderForTable(): void {
    if(this.children) {
      this.children.toArray().forEach(child => {
        child.clearSearch();
      });
    };
    let fieldId = this.fieldId;
    let fieldType = this.fieldType;
    this.table.header = [];
    this.headerLabels = this.getHeaderLabels();
    if(this.headerLabels.top && this.headerLabels.bottom) {
      if(!this.isKeywords && !this.isPhrases) {
        let column: any = [
          { uniqueId: 'name', header: 'Dropdown', width: '210px', isHeaderTextHide: true, isSorting: true, isDropdown: true, dropdown: this.tableDropdown, isProject: true, isChildRow: true},
          { uniqueId: 'rating', header: this.headerLabels.display, width: '100px', isSorting: true, style: {header: 'flex-end', row: 'flex-end'} },
          { uniqueId: 'responses', header: 'Responses', width: '120px', isSorting: true, style: {header: 'flex-end', row: 'flex-end'}  },
          { uniqueId: 'weightage', header: 'Weightage (%)', width: '160px', isSorting: true, style: {header: 'flex-end', row: 'flex-end'}  },
          { uniqueId: 'top', header: this.headerLabels.top, width: '120px', isSorting: true, style: {header: 'flex-end', row: 'flex-end'}  },
          { uniqueId: 'bottom', header: this.headerLabels.bottom, width: '120px', isSorting: true, style: {header: 'flex-end', row: 'flex-end'}  },
        ];
        if(this.headerLabels.rating == 'NPS') {
          column.push({ uniqueId: 'toppercent', header: this.headerLabels.top + (' %'), width: '120px', isSorting: true, isHeaderTextHide: true, image: 'assets/images/top-outline.svg', style: {header: 'center', row: 'center'}  });
          column.push({ uniqueId: 'bottompercent', header: this.headerLabels.bottom + (' %'), width: '120px', isSorting: true, isHeaderTextHide: true, image: 'assets/images/bottom-outline.svg', style: {header: 'center', row: 'center'}  });
        } else {
          column.push({ uniqueId: 'toppercent', header: this.headerLabels.top + (' %'), width: '120px', isSorting: true, style: {header: 'center', row: 'center'}  });
          column.push({ uniqueId: 'bottompercent', header: this.headerLabels.bottom + (' %'), width: '120px', isSorting: true, style: {header: 'center', row: 'center'}  });
        }
        if(fieldType === 'project') {
          column.splice(1, 0, { uniqueId: 'status', header: 'Status', width: '100px', isBadge: true});
        }
        if (this.headerLabels.mid && fieldType === 'project') {
          column.splice(6, 0, { uniqueId: 'mid', header: this.headerLabels.mid, width: '120px', isSorting: true, style: {header: 'flex-end', row: 'flex-end'}  });
        } else if(this.headerLabels.mid) {
          column.splice(5, 0, { uniqueId: 'mid', header: this.headerLabels.mid, width: '120px', isSorting: true, style: {header: 'flex-end', row: 'flex-end'}  });
        }
        if (this.headerLabels.mid && fieldType === 'project') {
          if(this.headerLabels.rating == 'NPS') {
            column.splice(9, 0, { uniqueId: 'midpercent', header: this.headerLabels.mid + (' %'), width: '120px', isSorting: true, isHeaderTextHide: true, image: 'assets/images/mid-outline.svg', style: {header: 'center', row: 'center'}  });
          } else {
            column.splice(9, 0, { uniqueId: 'midpercent', header: this.headerLabels.mid + (' %'), width: '120px', isSorting: true, style: {header: 'center', row: 'center'}  });
          }
        } else if(this.headerLabels.mid) {
          if(this.headerLabels.rating == 'NPS') {
            column.splice(8, 0, { uniqueId: 'midpercent', header: this.headerLabels.mid + (' %'), width: '120px', isSorting: true, isHeaderTextHide: true, image: 'assets/images/mid-outline.svg', style: {header: 'center', row: 'center'}  });
          } else {
            column.splice(8, 0, { uniqueId: 'midpercent', header: this.headerLabels.mid + (' %'), width: '120px', isSorting: true, style: {header: 'center', row: 'center'}  });
          }
        }
        this.table.header = column;
      } else if(this.isKeywords || this.isPhrases) {
        let column: any = [
          { uniqueId: 'name', header: 'Text', width: '210px', isSorting: true },
          { uniqueId: 'rating', header: this.headerLabels.display, width: '100px', isSorting: true, style: {header: 'flex-end', row: 'flex-end'}  },
          { uniqueId: 'responses', header: 'Responses', width: '120px', isSorting: true, style: {header: 'flex-end', row: 'flex-end'}  },
          { uniqueId: 'weightage', header: 'Weightage (%)', width: '160px', isSorting: true, style: {header: 'flex-end', row: 'flex-end'}  },
          { uniqueId: 'top', header: this.headerLabels.top, width: '120px', isSorting: true, style: {header: 'flex-end', row: 'flex-end'}  },
          { uniqueId: 'bottom', header: this.headerLabels.bottom, width: '120px', isSorting: true, style: {header: 'flex-end', row: 'flex-end'}  },
        ];
        if(this.headerLabels.rating == 'NPS') {
          column.push({ uniqueId: 'toppercent', header: this.headerLabels.top + (' %'), width: '120px', isSorting: true, isHeaderTextHide: true, image: 'assets/images/top-outline.svg', style: {header: 'center', row: 'center'}  })
          column.push({ uniqueId: 'bottompercent', header: this.headerLabels.bottom + (' %'), width: '120px', isSorting: true, isHeaderTextHide: true, image: 'assets/images/bottom-outline.svg', style: {header: 'center', row: 'center'} })
        } else {
          column.push({ uniqueId: 'toppercent', header: this.headerLabels.top + (' %'), width: '120px', isSorting: true, style: {header: 'center', row: 'center'}  })
          column.push({ uniqueId: 'bottompercent', header: this.headerLabels.bottom + (' %'), width: '120px', isSorting: true, style: {header: 'center', row: 'center'} })
        }
        if (this.headerLabels.mid) {
          column.splice(5, 0, { uniqueId: 'mid', header: this.headerLabels.mid, width: '120px', isSorting: true, style: {header: 'flex-end', row: 'flex-end'} });
          if(this.headerLabels.rating == 'NPS') {
            column.splice(8, 0, { uniqueId: 'midpercent', header: this.headerLabels.mid + (' %'), width: '120px', isSorting: true, isHeaderTextHide: true, image: 'assets/images/mid-outline.svg', style: {header: 'center', row: 'center'} });
          } else {
            column.splice(8, 0, { uniqueId: 'midpercent', header: this.headerLabels.mid + (' %'), width: '120px', isSorting: true, style: {header: 'center', row: 'center'} });
          }
        }
        this.table.header = column;
      }
    } else {
      if(!this.isKeywords && !this.isPhrases) {
        let column: any = [
          { uniqueId: 'name', header: 'Dropdown', width: '210px', isSorting: true, isHeaderTextHide: true, isDropdown: true, dropdown: this.tableDropdown, isProject: true, isChildRow: true},
          { uniqueId: 'status', header: 'Status', width: '100px', isBadge: true},
          { uniqueId: 'responses', header: 'Responses', width: '120px', isSorting: true, style: {header: 'flex-end', row: 'flex-end'}  },
        ];
        this.table.header = column;
      } else if(this.isKeywords || this.isPhrases) {
        let column: any = [
          { uniqueId: 'name', header: 'Text', width: '210px', isSorting: true },
          { uniqueId: 'responses', header: 'Responses', width: '120px', isSorting: true, style: {header: 'flex-end', row: 'flex-end'}  },
        ];
        this.table.header = column;
      }
    }
    // this.callAPI();
    // this.callAPIforFooter();
  }

  private callAPIforFooter(): void {
    this.isLoading = true;
    let accountId: any = _.get(Helpers, 'accountDetails._id', null);
    let fromDate: any = _.get(Helpers, 'datePicker.startDate', null);
    let toDate: any = _.get(Helpers, 'datePicker.endDate', null);
    let isCustomDateRangeSelected: any = _.get(Helpers, 'datePicker.isCustomDateRangeSelected', null);
    let projectType: any = _.get(Helpers, 'projectType.project_type', null);
    let dateFilterType: any = _.get(Helpers, 'datePicker.dateFilterType', null);
    if(accountId === null || fromDate === null || toDate === null || isCustomDateRangeSelected === null || projectType === null || dateFilterType === null) {
      return;
    }
    let payload: any = {
      "from": fromDate,
      "to": toDate,
      "account_id": accountId,
      "rater_type": this.scalerRaterType,
      "is_custom_date_range_selected": isCustomDateRangeSelected,
      "view_type": "summary",
      "use_es": true,
      "project_type": projectType,
      "date_filter_type": dateFilterType,
      "universal_filter": _.get(Helpers, 'universalFilter', null),
    };
    this.applyComparisonApiDateRange(payload);
    this.responseAnalyticsService.getAccountScoresSummary(payload).pipe(takeUntil(this.destroy$)).subscribe(response => {
      if(response.message === 'Success') {
        // Footer current/previous are derived from row summaries (list API), not overall_summary.
        this.prepareTableFooter();
      } else {
        this.isError = true;
        this.isLoading = false;
      }
    })
  }

  private resolveOverallTotalFromSummary(summaryData: any): number {
    if (!summaryData) {
      return 0;
    }
    if (this.isKeywords || this.isPhrases) {
      return summaryData?.doc_count || 0;
    }
    return summaryData?.users_rater_primary_rating || 0;
  }

  private getSummaryWeightageTotals(): { currentOverallTotal: number; previousOverallTotal: number } {
    return {
      currentOverallTotal: Number(this.totalCount) || 0,
      previousOverallTotal: Number(this.previousTotalCount) || 0,
    };
  }

  private attachRowSummaryDeviations(rowObj: any, currentData: any, previousData: any): void {
    attachSummaryDeviations(
      rowObj,
      currentData,
      previousData,
      this.scalerRaterType == 3,
      undefined,
      this.getSummaryWeightageTotals()
    );
  }

  private aggregateSubAccountSummary(
    brandIds: string[],
    overallSummary: any,
    period: 'current' | 'previous'
  ): any {
    const summaries = brandIds
      .map((id) => overallSummary?.[id]?.summary?.[period])
      .filter((data) => !!data);
    return this.aggregateSummaries(summaries);
  }

  /** Sums row-level summary nodes into one summary used for Total footer deviations. */
  private aggregateSummaries(summaries: any[]): any {
    let response = 0;
    let docCount = 0;
    let top = 0;
    let mid = 0;
    let bottom = 0;
    let ratingSum = 0;
    let ratingCount = 0;

    (summaries || []).forEach((data) => {
      if (!data) {
        return;
      }
      const rowResponse = data?.users_rater_primary_rating || 0;
      const rowDocCount = data?.doc_count || 0;
      response += rowResponse;
      docCount += rowDocCount;
      top += data?.promoters || data?.top || data?.positives || 0;
      mid += data?.passives || data?.mid || 0;
      bottom += data?.detractors || data?.bottom || data?.negatives || 0;
      const ratingBase = (this.isKeywords || this.isPhrases) ? rowDocCount : rowResponse;
      if (this.scalerRaterType != 3 && typeof data?.average_rating === 'number' && ratingBase > 0) {
        ratingSum += data.average_rating;
        ratingCount += 1;
      }
    });

    const summary: any = {
      users_rater_primary_rating: response,
      doc_count: docCount,
      promoters: top,
      passives: mid,
      detractors: bottom,
    };
    if (this.scalerRaterType != 3 && ratingCount > 0) {
      summary.average_rating = ratingSum / ratingCount;
    }
    return summary;
  }

  private bindFooterSummariesFromRows(currentSummaries: any[], previousSummaries: any[]): void {
    this.footerCurrentSummary = this.aggregateSummaries(currentSummaries);
    this.footerPreviousSummary = this.aggregateSummaries(previousSummaries);
    this.totalCount = this.resolveOverallTotalFromSummary(this.footerCurrentSummary);
    this.previousTotalCount = this.resolveOverallTotalFromSummary(this.footerPreviousSummary);
  }

  private attachFooterSummaryDeviations(footerRow: any): void {
    if (!footerRow || !this.footerCurrentSummary) {
      return;
    }
    attachSummaryDeviations(
      footerRow,
      this.footerCurrentSummary,
      this.footerPreviousSummary,
      this.scalerRaterType == 3,
      undefined,
      this.getSummaryWeightageTotals()
    );
  }

  private prepareTableFooter(): void {
    this.table.footer = [];
    this.footerCurrentSummary = null;
    this.footerPreviousSummary = null;
    this.callAPI();
  }

  private callAPI(): void {
    this.isLoading = true;
    let accountId: any = _.get(Helpers, 'accountDetails._id', null);
    let fromDate: any = _.get(Helpers, 'datePicker.startDate', null);
    let toDate: any = _.get(Helpers, 'datePicker.endDate', null);
    let isCustomDateRangeSelected: any = _.get(Helpers, 'datePicker.isCustomDateRangeSelected', null);
    let projectType: any = _.get(Helpers, 'projectType.project_type', null);
    let dateFilterType: any = _.get(Helpers, 'datePicker.dateFilterType', null);
    if(accountId === null || fromDate === null || toDate === null || isCustomDateRangeSelected === null || projectType === null || dateFilterType === null) {
      return;
    }
    const payload: any = {
      account_id: accountId,
      from: fromDate,
      to: toDate,
      rater_type: this.scalerRaterType,
      view_type: "list",
      field_id: this.fieldId,
      field_type: this.fieldType,
      is_custom_date_range_selected: isCustomDateRangeSelected,
      project_type: projectType,
      date_filter_type: dateFilterType,
      universal_filter: _.get(Helpers, 'universalFilter', null),
    };
    if(this.fieldType === 'tag') {
      payload["tag_data_type"] = "string";
    }
    this.applyComparisonApiDateRange(payload);
    this.responseAnalyticsService.getAccountScoresSummary(payload).pipe(takeUntil(this.destroy$)).subscribe(response => {
      if(response.message === 'Success') {
        if(this.fieldType === 'project') {
          this.projectTableRowDataPrepare(response?.data?.overall_summary_details);
        } else {
          this.tagTableRowDataPrepare(response?.data?.overall_summary_details?.overall_summary);
        }
      } else {
        this.isError = true;
        this.isLoading = false;
      }
    })
  }

  private projectTableRowDataPrepare(data: any): void {
    this.table.row = [];
    this.isLoading = false;
    this.totalProject = Object.keys(data.brands).length;
    const brands: any = data?.brands;
    const overallSummary: any = data?.overall_summary;
    const subAccount: any = data?.sub_accounts;
    let totalResponse: number = 0;
    let totalTop: number = 0;
    let totalMid: number = 0;
    let totalBottom: number = 0;
    let totalRating: any = 0;
    let totalCount: number = 0;
    let brandIds: any = [];
    const currentSummaries: any[] = [];
    const previousSummaries: any[] = [];
    for(let key in overallSummary) {
      let currentData: any = overallSummary[key]?.summary?.current;
      let previousData: any = overallSummary[key]?.summary?.previous;
      currentSummaries.push(currentData);
      previousSummaries.push(previousData);
      totalResponse = totalResponse + currentData?.users_rater_primary_rating;
      if(currentData?.users_rater_primary_rating > 0) {
        totalCount = totalCount + 1;
        totalRating = totalRating + currentData?.average_rating;
      }
    }
    // Bind Total footer current/previous from row summaries before row weightage/deviation calc.
    this.bindFooterSummariesFromRows(currentSummaries, previousSummaries);
    let rowData: any = [];
    for(let key in subAccount) {
      let rowObj: any = {};
      rowObj.name = subAccount[key]?.name;
      rowObj.childRow = [];
      let brandId: any = subAccount[key]?.brand_ids;
      brandIds.push(...brandId);
      let accountResponse: number = 0;
      let accountTop: number = 0;
      let accountMid: number = 0;
      let accountBottom: number = 0;
      let accountRating: number = 0;
      let accountCount: number = 0;
      if(brandId && brandId.length > 0) {
        brandId.forEach(id => {
          if(!brands.hasOwnProperty(id)) {
            return;
          }
          let brandRowObj: any = {};
          brandRowObj.name = brands[id]?.name;
          brandRowObj.isProject = true;
          brandRowObj.projectId = id;
          brandRowObj.status = this.getProjectStatus(brands[id].project_info.project_status);
          let currentData: any = overallSummary[id]?.summary?.current;
          let previousData: any = overallSummary[id]?.summary?.previous;
          let response: number = (currentData?.users_rater_primary_rating || 0);
          let top: number = (currentData?.promoters || currentData?.top || currentData?.positives || 0);
          let mid: number = (currentData?.passives || currentData?.mid || 0);
          let bottom: number = (currentData?.detractors || currentData?.bottom || currentData?.negatives || 0);
          accountResponse = accountResponse + response;
          accountTop = accountTop + top;
          accountMid = accountMid + mid;
          accountBottom = accountBottom + bottom;
          brandRowObj.responses = this.responseAnalyticsService.formatNumber(response);
          brandRowObj._responsesRaw = response; // Store raw value for total calculation
          brandRowObj.weightage = this.totalCount && this.totalCount > 0 ? ((response / this.totalCount) * 100).toFixed(1).endsWith('.0') ? Math.floor(((response / this.totalCount) * 100)) : ((response / this.totalCount) * 100).toFixed(1) : 0;
          brandRowObj.top = this.responseAnalyticsService.formatNumber(top);
          brandRowObj._topRaw = top; // Store raw value for total calculation
          brandRowObj.mid = this.responseAnalyticsService.formatNumber(mid);
          brandRowObj._midRaw = mid; // Store raw value for total calculation
          brandRowObj.bottom = this.responseAnalyticsService.formatNumber(bottom);
          brandRowObj._bottomRaw = bottom; // Store raw value for total calculation
          brandRowObj.toppercent = response ? ((top / response) * 100).toFixed(1).endsWith('.0') ? Math.round((top / response) * 100) + '%' : ((top / response) * 100).toFixed(1) + '%' : '0%';
          brandRowObj.midpercent = response ? ((mid / response) * 100).toFixed(1).endsWith('.0') ? Math.round((mid / response) * 100) + '%' : ((mid / response) * 100).toFixed(1) + '%' : '0%';
          brandRowObj.bottompercent = response ? ((bottom / response) * 100).toFixed(1).endsWith('.0') ? Math.round((bottom / response) * 100) + '%' : ((bottom / response) * 100).toFixed(1) + '%' : '0%';
          if(this.headerLabels.rating === 'NPS') {
            let beforeRating: any = response ? ((top - bottom)/response)*100 : 'N/A';
            if(beforeRating !== 'N/A') {
              if (beforeRating < 0 && (beforeRating % 1 === -0.5 || beforeRating % 1 === 0.5)) {
                brandRowObj.rating = Math.floor(beforeRating);
              } else if (beforeRating > 0 && beforeRating % 1 === 0.5) {
                brandRowObj.rating = Math.ceil(beforeRating);
              } else {
                brandRowObj.rating = Math.round(beforeRating);
              }
            } else {
              brandRowObj.rating = beforeRating;
            }
          } else {
            accountRating =  currentData?.average_rating ? accountRating + currentData?.average_rating : 0;
            if(accountRating > 0) {
              accountCount = accountCount + 1;
            }
            if(response == 0) {
              brandRowObj.rating = 'N/A';
            } else {
              brandRowObj.rating = (currentData?.average_rating) ? currentData?.average_rating.toFixed(2) : 0;
            }
          }
          this.attachRowSummaryDeviations(brandRowObj, currentData, previousData);
          rowObj.childRow.push(brandRowObj);
          rowObj.responses = this.responseAnalyticsService.formatNumber(accountResponse);
          rowObj._responsesRaw = accountResponse; // Store raw value for total calculation
          rowObj.top = this.responseAnalyticsService.formatNumber(accountTop);
          rowObj._topRaw = accountTop; // Store raw value for total calculation
          rowObj.mid = this.responseAnalyticsService.formatNumber(accountMid);
          rowObj._midRaw = accountMid; // Store raw value for total calculation
          rowObj.bottom = this.responseAnalyticsService.formatNumber(accountBottom);
          rowObj._bottomRaw = accountBottom; // Store raw value for total calculation
          rowObj.weightage = this.totalCount && this.totalCount > 0 ? ((accountResponse / this.totalCount) * 100).toFixed(1).endsWith('.0') ? Math.floor((accountResponse / this.totalCount) * 100) : ((accountResponse / this.totalCount) * 100).toFixed(1) : 0;
          rowObj.toppercent = accountResponse ? ((accountTop / accountResponse) * 100).toFixed(1).endsWith('.0') ? Math.round((accountTop / accountResponse) * 100) + '%' : ((accountTop / accountResponse) * 100).toFixed(1) + '%' : '0%';
          rowObj.midpercent = accountResponse ? ((accountMid / accountResponse) * 100).toFixed(1).endsWith('.0') ? Math.round((accountMid / accountResponse) * 100) + '%' : ((accountMid / accountResponse) * 100).toFixed(1) + '%' : '0%';
          rowObj.bottompercent = accountResponse ? ((accountBottom / accountResponse) * 100).toFixed(1).endsWith('.0') ? Math.round((accountBottom / accountResponse) * 100) + '%' : ((accountBottom / accountResponse) * 100).toFixed(1) + '%' : '0%';
          if(this.headerLabels?.rating === 'NPS') {
            let beforeRating: any = accountResponse ? ((accountTop - accountBottom)/accountResponse)*100 : 'N/A';
            if(beforeRating !== 'N/A') {
              if (beforeRating < 0 && (beforeRating % 1 === -0.5 || beforeRating % 1 === 0.5)) {
                rowObj.rating = Math.floor(beforeRating);
              } else if (beforeRating > 0 && beforeRating % 1 === 0.5) {
                rowObj.rating = Math.ceil(beforeRating);
              } else {
                rowObj.rating = Math.round(beforeRating);
              }
            } else {
              rowObj.rating = beforeRating;
            }
          } else {
            if(accountCount == 0) {
              rowObj.rating = 'N/A';
            } else {
              rowObj.rating = accountCount ? (accountRating / accountCount).toFixed(2) : 0;
            }
          }
        });
        if (brandId && brandId.length > 0) {
          const validBrandIds = brandId.filter((id: string) => brands.hasOwnProperty(id));
          this.attachRowSummaryDeviations(
            rowObj,
            this.aggregateSubAccountSummary(validBrandIds, overallSummary, 'current'),
            this.aggregateSubAccountSummary(validBrandIds, overallSummary, 'previous')
          );
        }
      }
      totalTop = totalTop + accountTop;
      totalMid = totalMid + accountMid;
      totalBottom = totalBottom + accountBottom;
      rowData.push(rowObj);
    }
    for(let brandId in brands) {
      if(brandIds.indexOf(brandId) == -1) {
        let rowObj: any = {};
        let currentData: any = overallSummary[brandId]?.summary?.current;
        let previousData: any = overallSummary[brandId]?.summary?.previous;
        rowObj.status = this.getProjectStatus(brands[brandId].project_info.project_status);
        let response: number = (currentData?.users_rater_primary_rating || 0);
        let top: number = (currentData?.promoters || currentData?.top || currentData?.positives || 0);
        let mid: number = (currentData?.passives || currentData?.mid || 0);
        let bottom: number = (currentData?.detractors || currentData?.bottom || currentData?.negatives || 0);
        totalTop = totalTop + top;
        totalMid = totalMid + mid;
        totalBottom = totalBottom + bottom;
        rowObj.name = brands[brandId].name;
        rowObj.isProject = true;
        rowObj.projectId = brandId;
        rowObj.top = this.responseAnalyticsService.formatNumber(top);
        rowObj._topRaw = top; // Store raw value for total calculation
        rowObj.mid = this.responseAnalyticsService.formatNumber(mid);
        rowObj._midRaw = mid; // Store raw value for total calculation
        rowObj.bottom = this.responseAnalyticsService.formatNumber(bottom);
        rowObj._bottomRaw = bottom; // Store raw value for total calculation
        rowObj.responses = this.responseAnalyticsService.formatNumber(response);
        rowObj._responsesRaw = response; // Store raw value for total calculation
        rowObj.weightage = this.totalCount && this.totalCount > 0 ? ((response / this.totalCount)*100).toFixed(1).endsWith('.0') ? Math.floor(((response / this.totalCount)*100)) : ((response / this.totalCount)*100).toFixed(1) : 0;
        rowObj.toppercent = response ? ((top / response) * 100).toFixed(1).endsWith('.0') ? Math.round((top / response) * 100) + '%' : ((top / response) * 100).toFixed(1) + '%' : '0%';
        rowObj.midpercent = response ? ((mid / response) * 100).toFixed(1).endsWith('.0') ? Math.round((mid / response) * 100) + '%' : ((mid / response) * 100).toFixed(1) + '%' : '0%';
        rowObj.bottompercent = response ? ((bottom / response) * 100).toFixed(1).endsWith('.0') ? Math.round((bottom / response) * 100) + '%' : ((bottom / response) * 100).toFixed(1) + '%' : '0%';
        if(this.headerLabels?.rating === 'NPS') {
          let beforeRating: any = response ? ((top - bottom)/response)*100 : 'N/A';
          if(beforeRating !== 'N/A') {
            if (beforeRating < 0 && (beforeRating % 1 === -0.5 || beforeRating % 1 === 0.5)) {
              rowObj.rating = Math.floor(beforeRating);
            } else if (beforeRating > 0 && beforeRating % 1 === 0.5) {
              rowObj.rating = Math.ceil(beforeRating);
            } else {
              rowObj.rating = Math.round(beforeRating);
            }
          } else {
            rowObj.rating = beforeRating;
          }
        } else {
          if(response == 0) {
            rowObj.rating = 'N/A';
          } else {
            rowObj.rating = (currentData?.average_rating) ? currentData.average_rating.toFixed(2) : 0;
          }
        }
        this.attachRowSummaryDeviations(rowObj, currentData, previousData);
        rowData.push(rowObj);
      }
    }
    let dummyRow: any = [];
    if(rowData && rowData.length > 0) {
      let data = rowData[0];
      const lengthOfRowData: any = (7 - rowData.length);
      for(let i = 0; i < lengthOfRowData; i++) {
        let obj: any = {};
        for (let key in data) {
          if (data.hasOwnProperty(key)) {
            obj['blank'] = 'no data available, blank row';
          }
        }
        dummyRow.push(obj);
      }
    }
    rowData = [...rowData, ...dummyRow];
    this.table.row = rowData;
    // Only sum real data rows (exclude dummy rows) for NPS calculation
    const realRows = this.table.row.filter(row => !row.blank);
    // Flatten to only child rows if present, otherwise use the row itself
    const childRows = realRows.flatMap(row => (row.childRow && row.childRow.length > 0) ? row.childRow : [row]);
    const totalTopReal = childRows.reduce((sum, row) => sum + (row._topRaw || 0), 0);
    const totalBottomReal = childRows.reduce((sum, row) => sum + (row._bottomRaw || 0), 0);
    const totalMidReal = childRows.reduce((sum, row) => sum + (row._midRaw || 0), 0);
    const totalResponseReal = childRows.reduce((sum, row) => sum + (row._responsesRaw || 0), 0);
    let topPercent: any = totalResponseReal ? ((totalTopReal / totalResponseReal) * 100).toFixed(1).endsWith('.0') ? Math.round((totalTopReal / totalResponseReal) * 100) + '%' : ((totalTopReal / totalResponseReal) * 100).toFixed(1) + '%' : '0%';
    let midPercent: any = totalResponseReal ? ((totalMidReal / totalResponseReal) * 100).toFixed(1).endsWith('.0') ? Math.round((totalMidReal / totalResponseReal) * 100) + '%' : ((totalMidReal / totalResponseReal) * 100).toFixed(1) + '%' : '0%';
    let bottomPercent: any = totalResponseReal ? ((totalBottomReal / totalResponseReal) * 100).toFixed(1).endsWith('.0') ? Math.round((totalBottomReal / totalResponseReal) * 100) + '%' : ((totalBottomReal / totalResponseReal) * 100).toFixed(1) + '%' : '0%';
    let totalRowRating: any = 0;
    if(this.headerLabels.rating === 'NPS') {
      let beforeRating: any = totalResponseReal ? ((totalTopReal - totalBottomReal)/totalResponseReal)*100 : 'N/A';
      if(beforeRating !== 'N/A') {
        if (beforeRating < 0 && (beforeRating % 1 === -0.5 || beforeRating % 1 === 0.5)) {
          totalRowRating = Math.floor(beforeRating);
        } else if (beforeRating > 0 && beforeRating % 1 === 0.5) {
          totalRowRating = Math.ceil(beforeRating);
        } else {
          totalRowRating = Math.round(beforeRating);
        }
      } else {
        totalRowRating = beforeRating;
      }
    } else {
      if(totalCount == 0) {
        totalRowRating = 'N/A';
      } else {
        totalRowRating = totalCount ? (totalRating / totalCount).toFixed(2): 0;
      }
    }
    // Calculate total weightage as the sum of all row weightages
    let totalWeightage = this.table.row.reduce((sum, row) => {
      const w = typeof row.weightage === 'string' ? parseFloat(row.weightage) : row.weightage;
      return sum + (isNaN(w) ? 0 : w);
    }, 0);
    totalWeightage = Number(totalWeightage.toFixed(1));
    const projectFooterRow: any = {
      name: 'Total',
      responses: this.responseAnalyticsService.formatNumber(totalResponseReal),
      weightage: totalWeightage,
      top: this.responseAnalyticsService.formatNumber(totalTopReal),
      mid: this.responseAnalyticsService.formatNumber(totalMidReal),
      bottom: this.responseAnalyticsService.formatNumber(totalBottomReal),
      toppercent: topPercent,
      midpercent: midPercent,
      bottompercent: bottomPercent,
      rating: totalRowRating
    };
    this.attachFooterSummaryDeviations(projectFooterRow);
    this.table.footer = [projectFooterRow];
  }

  private tagTableRowDataPrepare(data: any): void {
    this.table.row = [];
    this.isLoading = false;
    let totalResponse: number = 0;
    let totalTop: number = 0;
    let totalMid: number = 0;
    let totalBottom: number = 0;
    let totalRating: number = 0;
    let totalCount: number = 0;
    const currentSummaries: any[] = [];
    const previousSummaries: any[] = [];
    for(let key in data) {
      const currentData: any = data[key]?.summary?.current;
      const previousData: any = data[key]?.summary?.previous;
      currentSummaries.push(currentData);
      previousSummaries.push(previousData);
      if(this.isKeywords || this.isPhrases) {
        totalResponse = totalResponse + (currentData?.doc_count || 0);
        if(currentData?.doc_count && currentData?.doc_count > 0) {
          totalCount = totalCount + 1;
        }
      } else {
        totalResponse = totalResponse + (currentData?.users_rater_primary_rating || 0);
        if(currentData?.users_rater_primary_rating && currentData?.users_rater_primary_rating > 0) {
          totalCount = totalCount + 1;
        }
      }
    }
    // Bind Total footer current/previous from row summaries before row weightage/deviation calc.
    this.bindFooterSummariesFromRows(currentSummaries, previousSummaries);
    let rowData: any = [];
    for(let key in data) {
      let rowObj: any = {}
      let currentData: any = data[key]?.summary?.current;
      let previousData: any = data[key]?.summary?.previous;
      let response: any = 0;
      if(this.isKeywords || this.isPhrases){
         response = currentData?.doc_count || 0;
      }else{
        response = currentData?.users_rater_primary_rating || 0;
      }
      // if(response > 0) {
        rowObj.name = key;
        let top: number = (currentData?.promoters || currentData?.top || currentData?.positives || 0);
        let mid: number = (currentData?.passives || currentData?.mid || 0);
        let bottom: number = (currentData?.detractors || currentData?.bottom || currentData?.negatives || 0);
        totalTop = totalTop + top;
        totalMid = totalMid + mid;
        totalBottom = totalBottom + bottom;
        rowObj.responses = this.responseAnalyticsService.formatNumber(response);
        rowObj.weightage = this.totalCount && this.totalCount > 0 ? ((response / this.totalCount) * 100).toFixed(1).endsWith('.0') ? Math.floor((response / this.totalCount) * 100) : ((response / this.totalCount) * 100).toFixed(1) : 0;
        rowObj.top = top;
        rowObj.mid = mid;
        rowObj.bottom = bottom;
        rowObj.toppercent = response ? ((top / response) * 100).toFixed(1).endsWith('.0') ? Math.round((top / response) * 100) + '%' : ((top / response) * 100).toFixed(1) + '%' : '0%';
        rowObj.midpercent = response ? ((mid / response) * 100).toFixed(1).endsWith('.0') ? Math.round((mid / response) * 100) + '%' : ((mid / response) * 100).toFixed(1) + '%' : '0%';
        rowObj.bottompercent = response ? ((bottom / response) * 100).toFixed(1).endsWith('.0') ? Math.round((bottom / response) * 100) + '%' : ((bottom / response) * 100).toFixed(1) + '%' : '0%';
        if(this.headerLabels.rating === 'NPS') {
          let beforeRating: any = response ? ((top - bottom)/response)*100 : 'N/A';
          if(beforeRating !== 'N/A') {
            if (beforeRating < 0 && (beforeRating % 1 === -0.5 || beforeRating % 1 === 0.5)) {
              rowObj.rating = Math.floor(beforeRating);
            } else if (beforeRating > 0 && beforeRating % 1 === 0.5) {
              rowObj.rating = Math.ceil(beforeRating);
            } else {
              rowObj.rating = Math.round(beforeRating);
            }
          } else {
            rowObj.rating = beforeRating;
          }
        } else {
          totalRating = totalRating + currentData?.average_rating;
          if(response > 0) {
            rowObj.rating = currentData?.average_rating.toFixed(2);
          } else {
            rowObj.rating = 'N/A';
          }
        }
        this.attachRowSummaryDeviations(rowObj, currentData, previousData);
        rowData.push(rowObj);
      // }
    }
    if(this.table.header[0]?.isDropdown) {
      let dummyRow: any = [];
      if(rowData && rowData.length > 0) {
        let data = rowData[0];
        const lengthOfRowData: any = (7 - rowData.length);
        for(let i = 0; i < lengthOfRowData; i++) {
          let obj: any = {};
          for (let key in data) {
            if (data.hasOwnProperty(key)) {
              obj['blank'] = 'no data available, blank row';
            }
          }
          dummyRow.push(obj);
        }
      }
      rowData = [...rowData, ...dummyRow];
      this.table.row = rowData; 
    } else {
      this.table.row = rowData;
    }
    let topPercent: any = totalResponse ? ((totalTop / totalResponse) * 100).toFixed(1).endsWith('.0') ? Math.round((totalTop / totalResponse) * 100) + '%' : ((totalTop / totalResponse) * 100).toFixed(1) + '%' : '0%';
    let midPercent: any = totalResponse ? ((totalMid / totalResponse) * 100).toFixed(1).endsWith('.0') ? Math.round((totalMid / totalResponse) * 100) + '%' : ((totalMid / totalResponse) * 100).toFixed(1) + '%' : '0%';
    let bottomPercent: any = totalResponse ? ((totalBottom / totalResponse) * 100).toFixed(1).endsWith('.0') ? Math.round((totalBottom / totalResponse) * 100) + '%' : ((totalBottom / totalResponse) * 100).toFixed(1) + '%' : '0%';
    let rating: any = 0;
    if(this.headerLabels.rating === 'NPS') {
      let beforeRating: any = totalResponse ? ((totalTop - totalBottom)/totalResponse)*100 : 'N/A';
      if(beforeRating !== 'N/A') {
        if (beforeRating < 0 && (beforeRating % 1 === -0.5 || beforeRating % 1 === 0.5)) {
          rating = Math.floor(beforeRating);
        } else if (beforeRating > 0 && beforeRating % 1 === 0.5) {
          rating = Math.ceil(beforeRating);
        } else {
          rating = Math.round(beforeRating);
        }
      } else {
        rating = beforeRating;
      }
    } else {
      if(totalCount > 0) {
        rating = totalCount ? (totalRating / totalCount).toFixed(2) : 'N/A';
      } else {
        rating = 'N/A';
      }
    }
    const tagFooterRow: any = {
      name: 'Total',
      responses: this.responseAnalyticsService.formatNumber(totalTop + totalMid + totalBottom),
      weightage: (totalTop + totalMid + totalBottom) > 0 ? 100 : 0,
      top: this.responseAnalyticsService.formatNumber(totalTop),
      mid: this.responseAnalyticsService.formatNumber(totalMid),
      bottom: this.responseAnalyticsService.formatNumber(totalBottom),
      toppercent: topPercent,
      midpercent: midPercent,
      bottompercent: bottomPercent,
      rating: rating
    };
    this.attachFooterSummaryDeviations(tagFooterRow);
    this.table.footer = [tagFooterRow];
  }

  private getHeaderLabels(): any {
    let npsDisplayName: string = _.get(Helpers, 'accountDetails.label_configs.NPS.value', 'NPS');
    if (!npsDisplayName) {
      npsDisplayName = 'NPS';
    }
    const obj = { top: '', mid: '', bottom: '', rating: 'Rating', display: 'Rating' };
    const mapRaterTypeToLabels = {
      '3': { top: 'Promoters', mid: 'Passives', bottom: 'Detractors', rating: 'NPS', display: npsDisplayName },
      '6': { top: 'T3B', mid: 'MB', bottom: 'B3B' },
      '7': { top: 'T3B', mid: 'MB', bottom: 'B3B' },
      '5': { top: 'T2B', mid: 'MB', bottom: 'B2B' },
      '4': { top: 'T2B', mid: 'MB', bottom: 'B2B' },
      '9': { top: 'T2B', mid: 'MB', bottom: 'B2B' },
      '1': { top: 'Positive', mid: '', bottom: 'Negative' },
      '8': { top: 'T3B', mid: 'MB', bottom: 'B3B' },
      '2': { top: 'Positive', mid: '', bottom: 'Negative' }
    };
    const raterTypeKey = this.scalerRaterType !== undefined ? this.scalerRaterType.toString() : null;
    const labels = raterTypeKey && mapRaterTypeToLabels[raterTypeKey];
    return labels ? { ...obj, ...labels } : obj;
  }

  private getProjectStatus(id: any): any {
    if(id == 2 || id == '2') {
      return 'Live';
    } else if(id == 1 || id == '1') {
      return 'In setup';
    } else if(id == 3 || id == '3') {
      return 'Closed';
    } else if(id == 4 || id == '4') {
      return 'On hold';
    }
  }
    
  onDownload(): void {
    if (this.table.row.length === 0) {
      return;
    }
    let tableHeaders = this.table.header;
    tableHeaders[0]['header'] = this.isKeywords ? 'Top 100 keywords' : this.isPhrases ? 'Top 100 key phrases' :  this.tableDropdown.selectedOption
    let tableRowData: any = [];
    this.table.row.forEach(parentRow => {
      // Skip blank rows
      if (!parentRow.blank || parentRow.blank !== "no data available, blank row") {
        // Push the parent row data
        tableRowData.push(parentRow);
        if (parentRow.childRow && parentRow.childRow.length > 0) {
          parentRow.childRow.forEach(childRow => {
            let childRowData = { ...childRow };
            childRowData.isChildRow = true;
            tableRowData.push(childRowData);
          });
        }
      }
    });
    // Add the footer data if present
    if (this.table.footer.length > 0) {
      tableRowData.push(this.table.footer[0]);
    }
    let downloadConfig: any = {
      dataKey: 'uniqueId',
      headerKey: 'header',
      data: []
    };
    if (tableRowData.length > 0) {
      downloadConfig.data.push({ columns: tableHeaders, rows: tableRowData });
    }
    downloadConfig.fileDetails = {
      title: `Score Details - By ${this.isKeywords ? 'Top 100 keywords' : this.isPhrases ? 'Top 100 key phrases' :  this.tableDropdown.selectedOption}`,
      fileName: `Score Details - By ${this.isKeywords ? 'Top 100 keywords' : this.isPhrases ? 'Top 100 key phrases' :  this.tableDropdown.selectedOption}`,
      accountName: Helpers?.accountDetails.display_name || Helpers?.accountDetails.name,
    };
    if (downloadConfig.data.length) {
      this.responseAnalyticsService.prepareAndDownloadData(downloadConfig);
    }
  }

  prepareTableInfoToCSV(): string {
    let obj = {
      'Report name :': `Score Comparison - ${this.distributionSearchPlaceHolder}${this.compareWithSearchPlaceHolder ? `, ${this.compareWithSearchPlaceHolder}` : ''}`,
      'Report Date :': `${moment(Helpers?.datePicker?.formatedStartDate, "DD MMM' YY").format('DD-MMM-YYYY')} - ${moment(Helpers?.datePicker?.formatedEndDate, "DD MMM' YY").format('DD-MMM-YYYY')}`,
      'For Account :': Helpers?.accountDetails?.display_name || Helpers?.accountDetails?.name,
      'Interaction :': this.isKeywords ? 'Top 100 keywords' : this.isPhrases ? 'Top 100 key phrases' : this.tableDropdown.selectedOption,
      'Downloaded On :': `"${moment().format('DD-MMM-YYYY hh:mm:ss a')}"`,
      'Downloaded By :': Helpers?.managerDetails?.manager?.email_address
    };

    const rows = Object.entries(obj).map(([key, value]) => {
      if (typeof value === 'string' && (value.includes(',') || value.includes('\n') || value.includes('"'))) {
        value = `"${value.replace(/"/g, '""')}"`;
      }
      return `${key},${value}`;
    });

    const csv = rows.join('\n');
    return csv;
  }

  generateCSV(headers: any[], rows: any[], footer: any[]): string {
    const wrapInQuotes = (value: string) => {
      if (typeof value === 'string') {
        if (value.includes('"')) {
          value = `"${value.replace(/"/g, '""')}"`;
        } else if (value.includes(',') || value.includes('\n')) {
          value = `"${value}"`;
        }
      }
      return value;
    };

    // Generate header row
    const headerRow = headers.map(col => wrapInQuotes(col.header)).join(',');

    // Generate data rows
    const dataRows = rows.map(row => {
      const rowData = headers.map(col => {
        // Check if the column is for a child row
        if (col.isChildRow && row.childRow) {
          return row.childRow.map(child => wrapInQuotes(child[col.uniqueId])).join(',');
        }
        return wrapInQuotes(row[col.uniqueId]);
      }).join(',');
      return rowData;
    }).join('\n');

    // Generate footer rows
    const footerRows = footer.map(row => {
      return headers.map(col => wrapInQuotes(row[col.uniqueId])).join(',');
    }).join('\n');

    // Combine all parts into a single CSV string
    return `${headerRow}\n${dataRows}\n${footerRows}`;
  }

  sendReportForDownload(processedFile: any): void {
    var uri = 'data:text/csv;charset=utf-8,%EF%BB%BF' + encodeURIComponent(processedFile);
    const downloadData = {
      _id: this.downloadService.getDownloadId(),
      filename: `Score Comparison - ${this.distributionSearchPlaceHolder}${this.compareWithSearchPlaceHolder ? `, ${this.compareWithSearchPlaceHolder}` : ''} ${moment().format('DD-MMM-YYYY')}`,
      orignal_filename: `Score Comparison - ${this.distributionSearchPlaceHolder}${this.compareWithSearchPlaceHolder ? `, ${this.compareWithSearchPlaceHolder}` : ''} ${moment().format('DD-MMM-YYYY')}` + ".csv",
      fileType: 'csv',
      dataSource: 'dashboard',
      progress: 100,
      uri: uri
    };
    this.downloadService.updateList(downloadData);
    this.downloadService.showDownloadSideBar(true);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private applyComparisonApiDateRange(payload: any): void {
    if (!payload) {
     return;
    }
    applyComparisonApiDateRange(
     payload,
     _.get(Helpers, 'datePicker', null)
    );
  }
}